import encode from 'form-urlencoded';
import { CheckTransferInStatus, WixWarTransferInStatusToCheckStatusMap } from '../typing';
import { parseDomain } from '../utils';
import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { toASCII } from 'punycode';
export const WixWarServiceConfig = {
  name: 'WixWarApiConfig',
  baseUrl: '/_api/wix',
  requestTransform: req => encode(req),
  requestOptions: {
    headers: {
      authorization: null,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
};
export const WixWarApiConfig = {
  domainPurchaseData: {
    service: WixWarServiceConfig,
    name: 'domainPurchaseData',
    path: '/domainPurchaseData'
  },
  checkTransferInStatus: {
    service: WixWarServiceConfig,
    name: 'checkTransferInStatus',
    path: '/domainTransferInValidation',
    requestTransform: req => ({
      ...req,
      domainName: req.domainName ? toASCII(req.domainName) : undefined
    }),
    responseTransform: res => ({
      status: WixWarTransferInStatusToCheckStatusMap[res.status] ?? CheckTransferInStatus.TRANSFER_NOT_ALLOWED
    })
  },
  domainPurchaseNoSessionSetContract: {
    service: WixWarServiceConfig,
    name: 'domainPurchaseNoSessionSetContract',
    path: '/domainPurchaseNoSessionSetContract',
    requestTransform: _ref => {
      let {
        contactInfo,
        domainName,
        isRenewal,
        purchaseId,
        selectedDomainSku,
        siteGuid,
        skipContactsValidation,
        templateId
      } = _ref;
      return {
        ...convertContactInfoToOldFormat(contactInfo),
        domainName,
        isRenewal,
        templateId: templateId ?? 'template5',
        selectedDomainSku: selectedDomainSku ?? -1,
        siteGuid,
        skipContactsValidation: skipContactsValidation ?? true,
        purchaseId
      };
    }
  },
  domainYearlyPrice: {
    service: WixWarServiceConfig,
    name: 'domainYearlyPrice',
    path: '/domainPurchaseData',
    queryConfigType: QueryConfigTypes.STATIC_DATA,
    keyTransform: req => parseDomain(req.domainName).tld,
    responseTransform: convertFromPurchaseDataToYearlyPrice
  }
};
function isSameAsRegistrant(registrant, contact2) {
  if (Object.keys(registrant).length !== Object.keys(contact2).length) {
    return false;
  }
  return Object.keys(registrant).every(key => {
    return registrant[key] === contact2[key];
  });
}
export function convertContactInfoToOldFormat(contactInfo) {
  const contactInfoInOldFormat = {};
  const contactTypes = ['registrant'];
  contactInfoInOldFormat.adminSameAsRegistrant = contactInfo.admin === undefined ? true : isSameAsRegistrant(contactInfo.registrant, contactInfo.admin);
  contactInfoInOldFormat.techSameAsRegistrant = contactInfo.tech === undefined ? true : isSameAsRegistrant(contactInfo.registrant, contactInfo.tech);
  if (!contactInfoInOldFormat.adminSameAsRegistrant) {
    contactTypes.push('admin');
  }
  if (!contactInfoInOldFormat.techSameAsRegistrant) {
    contactTypes.push('tech');
  }
  contactTypes.reduce((acc, type) => {
    Object.keys(contactInfo[type] || {}).forEach(key => {
      acc[type + key.charAt(0).toUpperCase() + key.slice(1)] = contactInfo[type][key];
    });
    return acc;
  }, contactInfoInOldFormat);
  return {
    ...contactInfoInOldFormat,
    ...contactInfo.extraFields
  };
}
export function convertFromPurchaseDataToYearlyPrice(_ref2) {
  let {
    data
  } = _ref2;
  if (!(data != null && data.skus)) {
    return {
      amount: undefined,
      currency: undefined,
      displayedPrice: undefined
    };
  }
  const eligibleSkus = data.skus.filter(sku => !sku.privacyIncluded && !sku.voucherPlan);
  const minCycleYears = Math.min(...eligibleSkus.map(sku => sku.cycleYears ?? Infinity));
  const selectedSku = eligibleSkus.find(sku => sku.cycleYears === minCycleYears);
  const domainYearlyPrice = selectedSku == null ? void 0 : selectedSku.yearlyPrice;
  if (!domainYearlyPrice) {
    return {};
  }
  const currencySymbol = data.currencySymbol;
  const charCodeRegex = /&#(\d+);/g;
  const currencyFormattedSymbol = currencySymbol.replace(charCodeRegex, (_match, code) => String.fromCharCode(code));
  const displayedPrice = `${currencyFormattedSymbol}${domainYearlyPrice}`;
  return {
    amount: domainYearlyPrice,
    currency: currencySymbol,
    displayedPrice
  };
}
//# sourceMappingURL=WixWarApiConfig.js.map